import { useEffect, useRef, useState } from "react";
import { Input, Space, Button, Table, message, Typography, Divider } from 'antd';
import { ColumnsType } from "antd/es/table";
import { ReloadOutlined } from '@ant-design/icons';
import modal from "antd/es/modal";
import dayjs from "dayjs";
import AttributeRuleEdit from "../attributeruleedit/AttributeRuleEdit";
import EUtils, { IButtonConfig } from "../../../utils/EUtils";
import Server from "../../../server/Server";
import URL from "../../../server/URL";
import ESearch, { IMoreConfig, ISearchConfig } from "../../../components/esearch/ESearch";
const { Search } = Input;


const AttributeRule = () => {
    const [dataSource, setDataSource] = useState<any>([]);
    const [page, setPage] = useState<any>({ pageSize: 50, pageIndex: 1 });
    const [total, setTotal] = useState(0);

    const [editRecord, setEditRecord] = useState<any>(null);

    const refESearch = useRef<any>(null);
    const refAttributeRuleEdit = useRef<any>(null);

    const columns: ColumnsType<any> = [
        {
            title: '规则名称', dataIndex: 'attributeRuleName', key: 'attributeRuleName', fixed: 'left', ellipsis: true
            , width: 100,
            render(value, record, index) {
                return <a onClick={() => {
                    onOpen(2, record);
                }}>{value}</a>
            },
        },
        { title: '规则类型', dataIndex: 'type', key: 'type', width: 100, ellipsis: true, },
        { title: '规则描述', dataIndex: 'remark', key: 'remark', ellipsis: true, },
        { title: '创建人', dataIndex: 'createBy', key: 'roleName', width: 100, ellipsis: true, },
        {
            title: '创建时间', dataIndex: 'createTime', key: 'roleName', width: 100, ellipsis: true,
            render(value, record, index) {
                return dayjs(value).format('YYYY-MM-DD HH:mm')
            },
        },
        { title: '修改人', dataIndex: 'updateBy', key: 'updateBy', width: 100, ellipsis: true },
        {
            title: '修改时间', dataIndex: 'updateTime', key: 'updateTime', width: 100, ellipsis: true,
            render(value, record, index) {
                return dayjs(value).format('YYYY-MM-DD HH:mm')
            },
        },
        {
            title: <>
                {'操作'}
                <span style={{ float: 'right' }}>
                    <Divider type='vertical' />
                    <ReloadOutlined onClick={() => onLoad()} />
                </span>
            </>, align: 'center', fixed: 'right', width: 100, ellipsis: true,
            render(value, record, index) {
                var configs: IButtonConfig[] = [
                    { name: '查看', onClick: () => { onOpen(2, record); } },
                    { name: '编辑', onClick: () => { onOpen(1, record); }, },
                    {
                        name: '设置属性', onClick: () => {
                            window.location.href = '/rule/attributerule/attributeruleview?attributeRuleID=' + record.attributeRuleID;
                        },
                    },
                ];
                return EUtils.InitButtons(configs);
            },
        },]

    const [scrollY, setScrollY] = useState("");
    const resize = () => setScrollY(EUtils.getTableScroll(75, ''))
    //页面加载完成后才能获取到对应的元素及其位置
    useEffect(() => {
        resize();
    }, [dataSource])

    useEffect(() => {
        onLoad();
    }, [page])

    const onLoad = () => {
        var request = {
            ...page,
            options: refESearch.current?.getOptions()
        };
        Server.Post(URL.AttributeRule.GetAttributeRuleList, request).then((response: any) => {
            if (response.isSuccess) {
                setDataSource(response.data);
                setTotal(response.total);
            }
        })
    }

    const onOpen = (viewMode: number, record: any) => {
        setEditRecord({
            viewMode: viewMode,
            attributeRuleID: record?.attributeRuleID,
        });
        refAttributeRuleEdit.current.setVisible(true);
    }

    const searchConfig: ISearchConfig[] = [
        { filedID: 'attributeRuleName', filedName: '规则名称' },
        { filedID: 'type', filedName: '规则类型' },
        { filedID: 'remark', filedName: '规则描述' },
    ]
    const moreConfig: IMoreConfig[] = [
        {
            type: 'select', title: '规则类型', filedID: 'TypeEnum', data: [
                { value: 0, label: '比价产品批次属性' },
            ]
        }
    ]

    return <div>
        <ESearch showBU
            searchConfig={searchConfig}
            moreConfig={moreConfig}
            onLoad={onLoad}
            resize={resize}
            ref={refESearch} />
        <div style={{ backgroundColor: '#fafafa', border: '1px solid #e7e7eb', borderBottom: 'none', padding: '5px' }}>
            <span style={{ lineHeight: '32px', margin: '5px', fontWeight: 'bold' }}></span>
            <Space style={{ float: 'right' }}>
                <Button type="primary" onClick={() => {
                    onOpen(0, null)
                }}>新增</Button>
            </Space>
        </div>
        <Table size="small" bordered
            scroll={dataSource?.length > 0 ? { x: 'max-content', y: scrollY } : { x: 'max-content' }}
            columns={columns}
            dataSource={dataSource} pagination={{
                position: ['bottomRight'],
                style: { marginRight: '10px' },
                showSizeChanger: true,
                showQuickJumper: true,
                total: total,
                showTotal: ((total: number) => {
                    return "共" + total + "条";
                }),
                current: page.pageIndex,
                defaultCurrent: 20,
                pageSize: page.pageSize,
                pageSizeOptions: [10, 20, 50, 100, 200],
                onShowSizeChange: ((page: any, pageSize: number) => {
                    setPage({
                        pageIndex: page,
                        pageSize: pageSize
                    });
                }),
                onChange: ((page: any, pageSize: number) => {
                    setPage({
                        pageIndex: page,
                        pageSize: pageSize
                    });
                })
            }}
            summary={(pageData) => {
                return (
                    <Table.Summary fixed>
                        <Table.Summary.Row>
                            <Table.Summary.Cell index={0}>
                                <Typography>{'合计：' + pageData.length}</Typography>
                            </Table.Summary.Cell>
                            <Table.Summary.Cell index={1} colSpan={6}></Table.Summary.Cell>
                            <Table.Summary.Cell index={2} colSpan={2}></Table.Summary.Cell>
                        </Table.Summary.Row>
                    </Table.Summary>
                );
            }} />
        <AttributeRuleEdit {...editRecord} reLoad={onLoad} ref={refAttributeRuleEdit} />
    </div>
}
export default AttributeRule;
